import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPackage"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V21H21V3H16V10H8V3H3ZM14 16.5V18H18V16.5H14Z" fill="currentColor"/><Path d="M9.5 3H14.5V8.5H9.5V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackage;
